<template>
    <BRow>
        <BCol md="6" lg="6">
            <BFormGroup
                :label="$t('Component(Placeholder):product-weight')"
                label-for="workflow-product-weight"
            >
                <BFormInput
                    id="workflow-product-weight"
                    type="number"
                    class="input-bg-warning"
                    :placeholder="$t('Component(Placeholder):product-weight')"
                    :value="value"
                    @input="$emit('change', $event)"
                />
            </BFormGroup>
        </BCol>
    </BRow>
</template>

<script>
import {
    BCol,
    BFormGroup,
    BFormInput,
    BRow,
} from 'bootstrap-vue'

export default {
    name: 'WorkflowProductWeightSection',
    components: {
        BCol,
        BFormGroup,
        BFormInput,
        BRow,
    },
    props: {
        value: { type: [String, Number], default: null },
    },
}
</script>
